var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 2.5C17.7207 2.5 17.9326 2.5878 18.0889 2.74408C18.2452 2.90036 18.333 3.11232 18.333 3.33333V13.3333C18.333 13.5543 18.2452 13.7663 18.0889 13.9226C17.9326 14.0789 17.7207 14.1667 17.4997 14.1667H9.45884L5.52051 17.3175C5.39793 17.4156 5.25012 17.4772 5.0941 17.4949C4.93809 17.5127 4.78022 17.4861 4.63869 17.4181C4.49716 17.35 4.37773 17.2434 4.29416 17.1105C4.21059 16.9775 4.16628 16.8237 4.16634 16.6667V14.1667H2.49967C2.27866 14.1667 2.0667 14.0789 1.91042 13.9226C1.75414 13.7663 1.66634 13.5543 1.66634 13.3333V3.33333C1.66634 3.11232 1.75414 2.90036 1.91042 2.74408C2.0667 2.5878 2.27866 2.5 2.49967 2.5H17.4997ZM3.33301 12.5H4.99967C5.22069 12.5 5.43265 12.5878 5.58893 12.7441C5.74521 12.9004 5.83301 13.1123 5.83301 13.3333V14.9325L8.64551 12.6825C8.79335 12.5643 8.97704 12.4999 9.16634 12.5H16.6663V4.16667H3.33301V12.5Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSquare);
export default __webpack_public_path__ + "static/media/chatSquare.ce5d30c5d73ae2675f71ba942192393d.svg";
export { ForwardRef as ReactComponent };